module.exports = __webpack_public_path__ + "img/storyofchina.7bcd92dd.jpg";